import { DepartmentService } from './department.service';

export default angular
  .module('sfMobile.services.department', [
    'sfMobile.constants.department-types',
    'sfMobile.services.popup',
  ])
  .factory('departmentService', DepartmentService).name;
